module.exports = __webpack_public_path__ + "img/inquiry.f99983f0.svg";